export const isGoogleMapAvailable = () => ('google' in window && typeof window.google === 'object' && 'maps' in window.google! && typeof window.google.maps === 'object');
